import React from 'react';

import './BuildingNotFound.scss';

import commonConstant from '../../common/_commonConstant';

export default () => (
  <div className="BuildingNotFound">
    <img className="not-found" src={commonConstant.notFoundImg} alt="" />
    <div className="text-not-found">ไม่พบข้อมูล</div>
  </div>
);
